export var HEATMAP_MONITOR_PLUGIN_NAME = 'heatmap';
//# sourceMappingURL=heatmap.js.map